import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class Trigger extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false, hideMultipleDeletePopup: false
      });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    this.multipleDeleteButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteMultipleTriggerApi()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideMultipleDeletePopup: false,
        });
      }
    }];

    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteTriggerApi(this.state.propsId)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];

    this.state = {
      language: null,
      data: [
        {
          id: '',
          originalText: '',
          autoTranslate: '',
        }
      ],
      pageNum: null,
      intentId: '',
      domainId: '',
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit2.png',
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      checkBoxRows: [],
      selectedRows: [],
      disableMultipleDelete: true,
      hideMultipleDeletePopup: false
    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }

  notifyFailToLoad() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }

  addRow = (data) => {
    var triggerController = this;
    if (triggerController.state.pageNum != 0) {
      triggerController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      originalText: '',
      autoTranslate: '',
    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }

  addNewCellData = (props, e) => {
    this.state.data[props.index].originalText = document.getElementById('originalText' + props.index).innerText.trim();
    this.state.data[props.index].autoTranslate = document.getElementById('autoTranslate' + props.index).checked;
    this.state.editedId = "-1";
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.originalText, props.original.slotTemplate);

    if (validateResult == true) {
      var addedData = {
        originalText: this.state.data[props.index].originalText,
        autoTranslate: this.state.data[props.index].autoTranslate,
        language: document.getElementById('selectTriggerlanguage').value,
        intentId: this.props.location.state.intentId,
        projectId: localStorage.getItem("currentProjectId"),
        domainId: this.props.location.state.domainId
      };

      var addTriggerController = this
      $.ajax({
        url: "/api/slu-trigger",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type':
            'application/json'
        },
        data: JSON.stringify(addedData),
        success: function (res) {
          if (res.success === true) {
            addTriggerController.notifyAdd();
            addTriggerController.state.disabled = false;
            addTriggerController.fetchTriggerApi();
          } else {
            addTriggerController.notifyFailToAdd("The slot " + res.result + " is not defined in any intents in the hierarchy of this intent");
            addTriggerController.state.disabled = false;
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      })
    }
  }

  notifyAdd() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Trigger Added Successfully</b>, {
      position: "top-center",
    });
  }
  notifyFailToAdd(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  makeCelleditable(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }
  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  updateCell(props, e) {
    this.state.data[props.index].originalText = document.getElementById('originalText' + props.index).innerText.trim();
    this.state.data[props.index].autoTranslate = document.getElementById('autoTranslate' + props.index).checked;
    var validateResult = this.validateCells(props.original.originalText, props.original.slotTemplate);
    if (validateResult == true) {
      var updatedData = {
        id: this.state.data[props.index].id,
        originalText: this.state.data[props.index].originalText,
        autoTranslate: this.state.data[props.index].autoTranslate,
        language: document.getElementById('selectTriggerlanguage').value,
        intentId: this.props.location.state.intentId,
        projectId: localStorage.getItem("currentProjectId"),
        domainId: this.props.location.state.domainId,
      };
      var updatedDataController = this
      $.ajax({
        url: "/api/slu-trigger",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type':
            'application/json'
        },
        data: JSON.stringify(updatedData),
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.state.disabled = false;
            updatedDataController.fetchTriggerApi();
          } else {
            updatedDataController.notifyFailToUpdate("The slot " + res.result + " is not defined in any intents in the hierarchy of this intent");
            updatedDataController.state.disabled = false;
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      })
    }
  }
  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Trigger Updated Successfully</b>, {
      position: "top-center",

    });
  }
  notifyFailToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  validateCells(originalText) {
    if ((originalText == "")) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    else {
      return true;
    }

  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });

  }

  deleteTriggerApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    }
    $.ajax({
      url: "/api/slu-trigger/" + id,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {

        if (res.success === true) {

          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteRowViewController.splice(id, 1);
          deleteConstructorVariables.notifyMsgDeleteSuccess();
          deleteConstructorVariables.state.disabled = false;
          deleteConstructorVariables.fetchTriggerApi();

        } else {
          deleteConstructorVariables.notifyFailToDelete(res.result);
          deleteConstructorVariables.state.disabled = false;
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  notifyMsgDeleteSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;Trigger Deleted Successfully</b>, {
      position: "top-center"
    });
  }

  notifyFailToDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }



  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.state.selectedRows = [];
    this.state.disableMultipleDelete = true;
    this.state.checkBoxRows = [];
    this.fetchTriggerApi()
    this.setState({ disabled: false })
  }

  loadLanguages = () => {
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          'projectId': localStorage.getItem('currentProjectId'),
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            var loadlanguage = res.result;
            languageController.setState({ language: loadlanguage });
            var numberOfLanguages = loadlanguage.length;
            var ele3 = document.getElementById("selectTriggerlanguage");
            if (ele3 != null) {
              ele3.innerHTML = null;
              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + loadlanguage[i]['code'] +
                  '">' + loadlanguage[i]['name'] + '</option>';
              }
            }
          }
          else {
            languageController.notifyFailToLoadLanguages();
          }
        }
      }
    )
  }

  notifyFailToLoadLanguages() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages for Triggers.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }
  fetchTriggerApi = () => {
    var otherFormController = this;
    $.ajax({
      url: "/api/slu-trigger",
      async: false,
      method: 'GET',
      data: {
        "intentId": this.props.location.state.intentId,
        'language': document.getElementById('selectTriggerlanguage').value,
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          otherFormController.setState({
            data: messages,
            disabled: false,
          })
        }
        else {
          otherFormController.notifyFailToLoadData(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  notifyFailToLoadData(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  componentDidMount() {
    var intentId = this.props.location.state.intentId
    var domainId = this.props.location.state.domainId
    this.state = {
      intentId: intentId,
      domainId: domainId
    }

    setTimeout(() => {
      this.loadLanguages();
      this.fetchTriggerApi();
    }, 300);

    var TriggerLangController = this;
    document.addEventListener("projectChanged", function (event) {
      TriggerLangController.props.history.push("/projectmgmt/nlutab")
    });
  }

  handleLangChange = (e) => {
    this.state.disabled = false
    this.fetchTriggerApi();
  }

  goBack = () => {
    this.props.history.push({
      pathname: "/projectmgmt/nlutab",
      state: { goBackToSlu: true }
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  selectedRow = (props, e) => {
    this.state.selectedRows = [];
    var jsonData = props.original;
    for (var i = 0; i < this.state.checkBoxRows.length; i++) {
      if (this.state.checkBoxRows[i]["id"] == jsonData.id) {
        this.state.checkBoxRows.splice(i, 1);
      }
    }
    if (e.target.checked) {
      jsonData["selected"] = true;
    } else {
      jsonData["selected"] = false;
    }
    this.state.checkBoxRows.push(jsonData);
    for (var i = 0; i < this.state.checkBoxRows.length; i++) {
      if (this.state.checkBoxRows[i]["selected"] == true) {
        this.state.selectedRows.push(this.state.checkBoxRows[i]);
      }
    }
    if (this.state.selectedRows.length > 0) {
      this.state.disableMultipleDelete = false;
    } else {
      this.state.disableMultipleDelete = true;
    }
    this.setState(this.state);
  }

  deleteMultipleTriggerApi = () => {
    let deleteApiViewController = this;
    var idListVal = deleteApiViewController.state.selectedRows;
    var idList = [];
    for (var i = 0; i < idListVal.length; i++) {
      idList.push(idListVal[i].id);
    }

    $.ajax({
      url: "/api/slu-trigger-delete-multiple/" + idList,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

      success: function (res) {

        if (res.success === true) {
          deleteApiViewController.state.hideMultipleDeletePopup = false;
          deleteApiViewController.state.disableMultipleDelete = true;
          deleteApiViewController.state.checkBoxRows = [];
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.fetchTriggerApi();
          deleteApiViewController.notifyMultipleDeleteSuccess();
        } else {
          deleteApiViewController.notifyFailToDelete(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }

  notifyMultipleDeleteSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;Selected Triggers Deleted Successfully</b>, {
      position: "top-center",
    });

  }

  render() {
    const { data } = this.state
    const columns = [
      {
        Header: <b>Select</b>,
        accessor: "id",
        sortable: false,
        width: 55,
        Cell: props => (
          <div style={{ textAlign: 'center' }}>
            <input type="checkbox"
              disabled={props.original.id === "" ? true : false}
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={(e) => {
                this.selectedRow(props, e)
              }}
              checked={props.original.selected}
            />
          </div>)
      },
      {
        Header: 'Qno',
        accessor: 'id',
        show: false,
        Cell: props => (
          <div name="id" id={"id" + props.index}>{props.original.id}
          </div>)
      },
      {
        Header: <b> Text </b>,
        accessor: 'originalText',
        sortable: false,
        Cell: props => (<div className="input"
          style={{ width: '98%', padding: '8px', border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
          contentEditable={!((props.original.id == '') ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}
            
          suppressContentEditableWarning
          type="text" id={"originalText" + props.index}>{props.original.originalText}</div>)
      },
      {
        Header: <b> AutoTranslate </b>,
        accessor: 'autoTranslate',
        sortable: false,
        width: 100,
        Cell: props => {
          return (
            <div style={{ textAlign: 'center' }}>
              <label class="switch">
                <input type="checkbox"
                  id={"autoTranslate" + props.index}
                  defaultChecked={props.original.autoTranslate}
                  disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId} />
                <span class="slider round"></span>
              </label>
            </div>
          )
        }
      },
      {
        Header: <b> Action </b>,
        accessor: 'action',
        width: 100,
        sortable: false,
        Cell: props => (
          <div id="action">

            <button
              style={{
                backgroundColor: "transparent", border: "none",
                marginTop: '-13px'
              }}
            >
              <img className="img-responsive"
                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                title={(props.original.id == "") ||
                  (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                src={(props.original.id == "") ?
                  this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                    this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  (props.original.id == "") ?
                    this.addNewCellData(props, e) :
                    (props.original.id == this.state.editedId) ?
                      this.updateCell(props, e) :
                      this.makeCelleditable(props, e);
                }}
              />
            </button>
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                marginTop: '-9px', marginLeft: '-6px'
              }} title="Delete"
            >
              <img className="img-responsive"
                style={{
                  marginTop: '6px',
                  backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                }}
                src={"./assets/images/baseline_delete_white_24dp.png"}
                onClick={() => (props.original.id) === '' ?
                  this.fetchTriggerApi() :
                  this.setState({
                    hideDeletePopup: true, deletePropIndex: props.index,
                    propsId: props.original.id
                  })}
              />
            </button>

          </div>
        ),

      },

    ]
    return (
      <div style={{ background: "#F9F9FB" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
        <link rel="stylesheet" href="./assets/css/react-table-height.css" />

        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        {/* Font Awesome Icons */}
        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* IonIcons */}
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />

        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />

        <div className="content-header">
          <div className="container-fluid">
            <div className="row">

            </div>
            <div className="row">
              <div className="col-sm-3" style={{ marginTop: '16px' }}>
                <img src="assets/images/arrow.svg" title="Go Back"
                  onClick={this.goBack}
                  style={{ paddingRight: "30%", cursor: 'pointer' }} />
              </div>
              <div className="col-sm-4" Align='right'>
                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                  Triggers for {this.props.location.state.intentName}</h6>
              </div>

              {/* languages */}

              {/* Add button */}
              <div className="col-sm-5" Align='right'>
                <select className="input-group mb-3 form-control select2 "
                  style={{
                    display: 'inline-block',
                    width: '40%', marginRight: '3%'
                  }}
                  tabIndex={-1} aria-hidden="true"
                  name="selectTriggerlanguage" id="selectTriggerlanguage"
                  onChange={this.handleLangChange}>
                </select>
                <button className="btn action-button "
                  disabled={this.state.disableMultipleDelete}
                  title="Delete Selected"
                  id="deleteMultiple"
                  onClick={() => {
                    this.setState({
                      hideMultipleDeletePopup: true
                    })
                  }
                  }>
                  <img src={"./assets/images/baseline_delete_white_24dp.png"} />
                </button>
                <button className="btn action-button "
                  title="Add"
                  id="addMsg"
                  onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} className="btn action-button"
                  title="Refresh">
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>
            </div>
          </div>
          {/* left Menu start here*/}
          {/* Content Header (Page header) */}
          {/* /.content-header */}
          {/* Custom Tabs */}
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 ">
                  <div className="card">
                    <ReactTable
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo) {
                          return {
                            style: {
                              background: this.state.selectedRows.some((selectedRow) => selectedRow.id == rowInfo.original.id) ? '#E6E6D8' : 'white'
                            }
                          }
                        } else {
                          return {}
                        }
                      }
                      }
                      data={data}
                      columns={columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      onPageChange={this.onPageChange}
                      page={this.state.pageNum}
                    />
                  </div>
                  <ToastContainer className="Toast-at-center" />


                  {/*Dialog Component For Deletion Confirmation*/}
                  <DialogComponent width='400px' animationSettings={this.settings}
                    header='Trigger' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                      content="" />&nbsp;Do you want to delete the Trigger?
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                  {/*Dialog Component For Multiple Deletion Confirmation*/}
                  <DialogComponent width='400px' animationSettings={this.settings}
                    header='Trigger' showCloseIcon={true} buttons={this.multipleDeleteButton}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideMultipleDeletePopup} close={this.dialogClose}>
                    <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                      content="" />&nbsp;Do you want to delete the selected triggers?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                  </DialogComponent>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Trigger;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/intent/Trigger.js